// WOM: restyles the Shopify Forms app embed by reaching into its open shadow root
(function () {
  // Labels to hide visually; matched on text because the app's class names are hashed
  var HIDDEN_LABELS = ['resale certification', 'electronic signature'];

  // Field pairs shown side by side on desktop, keyed by the field ids set in the Forms app; split is the first field's share
  var ROWS = [
    { fields: ['custom#permit_state', 'custom#sales_tax_permit_number'], split: '36%' },
    { fields: ['custom#full_legal_name_of_person_certifying', 'custom#title'], split: '67%' },
  ];

  // Select fields whose visible label moves inside the dropdown as a placeholder
  var INLINE_SELECT_LABELS = ['custom#permit_state'];

  // Text labels inserted above a field, keyed by field id
  var HEADINGS = {
    'custom#permit_state': 'Resale Certificate',
  };

  // "?" tooltips, keyed by input id
  var TOOLTIPS = {
    'custom#sales_tax_permit_number':
      "Your sales tax permit number appears on the seller's permit or sales tax license issued by your state tax agency. Please do not enter your federal Employer Identification Number (EIN).",
  };

  var STYLES = [
    // Restores base.css's body slant pin, which the app resets on its title and buttons so iOS renders Gluten slanted
    '* { font-variation-settings: "slnt" 0 !important; }',
    '[data-wom-hidden] { position: absolute !important; width: 1px !important; height: 1px !important; margin: -1px !important; padding: 0 !important; overflow: hidden !important; clip: rect(0 0 0 0) !important; white-space: nowrap !important; border: 0 !important; }',
    '[data-wom-check-row] { align-items: flex-start !important; }',
    '[data-wom-check-row] > :not([data-wom-check-box]) { font-size: 12px !important; line-height: 1.4 !important; }',
    '[data-wom-check-box] { align-self: flex-start !important; margin-block-start: var(--wom-check-offset, 0px) !important; }',
    '[data-wom-wrap] { flex-flow: row wrap !important; }',
    '[data-wom-wrap] > * { flex: 1 1 100% !important; min-width: 0; }',
    '[data-wom-wrap] > [data-wom-row-start] { flex: 0 0 calc(var(--wom-row-split, 50%) - 6px) !important; }',
    '[data-wom-wrap] > [data-wom-row-end] { flex: 1 1 0 !important; }',
    '[data-wom-row-start]:has(> button) { display: flex !important; flex-direction: column; }',
    '[data-wom-row-start]:has(> button) > button { flex: 1 1 auto !important; height: auto !important; max-height: none !important; box-sizing: border-box; }',
    '[data-wom-select-placeholder] > [id$="-selector-value"]:empty::before { content: attr(data-wom-placeholder); color: var(--wom-placeholder-color, inherit); }',
    '[data-wom-heading] { margin: 0 !important; padding: 8px 0 0 !important; }',
    '[data-wom-tip-field] > input { padding-inline-end: 40px !important; }',
    '[data-wom-tip-field] > label { max-width: calc(100% - 55px); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }',
    '.wom-tip { position: absolute; inset-block-start: 50%; inset-inline-end: 12px; transform: translateY(-50%); display: flex; z-index: 2; }',
    '.wom-tip__btn { display: grid; place-items: center; width: 20px; height: 20px; padding: 0; border: 1.5px solid currentColor; border-radius: 50%; background: transparent; color: var(--color-background); font: inherit; font-size: 14px; font-weight: 700; line-height: 1; cursor: help; }',
    '.wom-tip__btn:focus-visible { outline: 2px solid var(--color-background); outline-offset: 2px; }',
    '.wom-tip__bubble { position: absolute; inset-block-end: calc(100% + 10px); inset-inline-end: -12px; box-sizing: border-box; width: max-content; max-width: min(460px, var(--wom-tip-max, calc(100vw - 32px))); padding: 16px 20px; border-radius: var(--style-border-radius-popover, 12px); background: var(--color-background); color: var(--color-foreground); box-shadow: 0 8px 24px color-mix(in srgb, var(--color-background) 30%, transparent); font-size: 14px; line-height: 1.6; text-align: start; opacity: 0; visibility: hidden; transition: opacity 0.15s ease, visibility 0.15s ease; pointer-events: none; }',
    '.wom-tip:hover .wom-tip__bubble, .wom-tip:has(.wom-tip__btn:focus-visible) .wom-tip__bubble, .wom-tip[data-open] .wom-tip__bubble { opacity: 1; visibility: visible; }',
    '[data-testid="btn-form-submit"] { --button-color: var(--color-primary-button-text); --button-background-color: var(--color-primary-button-background); --button-border-color: var(--color-primary-button-border); --button-border-width: var(--style-border-width-primary); color: var(--button-color) !important; background-color: var(--button-background-color) !important; border: none !important; box-shadow: inset 0 0 0 var(--button-border-width) var(--button-border-color) !important; border-radius: var(--style-border-radius-buttons-primary) !important; font-family: var(--button-font-family-primary) !important; font-weight: var(--button-font-weight-primary) !important; text-transform: var(--button-text-case-primary) !important; font-size: var(--wom-paragraph-size) !important; line-height: var(--wom-paragraph-line-height) !important; padding: var(--button-padding-block) var(--button-padding-inline) !important; height: auto !important; cursor: pointer; transition: color var(--animation-speed, 0.2s) var(--animation-easing, ease), box-shadow var(--animation-speed, 0.2s) var(--animation-easing, ease), background-color var(--animation-speed, 0.2s) var(--animation-easing, ease); }',
    '[data-testid="btn-form-submit"]:hover { --button-color: var(--color-primary-button-hover-text); --button-background-color: var(--color-primary-button-hover-background); --button-border-color: var(--color-primary-button-hover-border); }',
    '[data-testid="btn-form-submit"]:focus-visible { outline: 2px solid var(--color-primary-button-focus-outline) !important; outline-offset: 2px; }',
    '@media screen and (max-width: 749px) { [data-wom-wrap] > [data-wom-row-start], [data-wom-wrap] > [data-wom-row-end] { flex: 1 1 100% !important; } }',
  ].join('\n');

  /** @type {WeakSet<ShadowRoot>} */
  var enhanced = new WeakSet();

  /** @param {string | null} text */
  function normalize(text) {
    return (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  // Climbs to the outermost wrapper holding only the label text so its spacing goes too
  /** @param {Element} el @param {ShadowRoot} root */
  function labelWrapper(el, root) {
    var text = normalize(el.textContent);
    while (el.parentElement && el.parentNode !== root && normalize(el.parentElement.textContent) === text) {
      el = el.parentElement;
    }
    return el;
  }

  /** @param {ShadowRoot} root */
  function hideLabels(root) {
    var nodes = root.querySelectorAll('legend, label, p, span, div, h1, h2, h3, h4, h5, h6');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!el || el.hasAttribute('data-wom-hidden') || el.children.length) continue;
      if (HIDDEN_LABELS.indexOf(normalize(el.textContent)) === -1) continue;
      labelWrapper(el, root).setAttribute('data-wom-hidden', '');
    }
  }

  // Top-aligns each checkbox with the first line of its text; rows are found by layout since classes are hashed
  /** @param {ShadowRoot} root */
  function alignCheckboxes(root) {
    var inputs = root.querySelectorAll('input[type="checkbox"]:not([data-wom-aligned])');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (!input) continue;
      /** @type {Element} */
      var box = input;
      /** @type {Element | null} */
      var row = null;
      while (box.parentElement && box.parentNode !== root) {
        var parent = box.parentElement;
        var display = getComputedStyle(parent).display;
        if (/flex|grid/.test(display) && normalize(parent.textContent) !== normalize(box.textContent)) {
          row = parent;
          break;
        }
        box = parent;
      }
      if (!row) continue;
      var boxHeight = box.getBoundingClientRect().height;
      if (!boxHeight) continue;
      row.setAttribute('data-wom-check-row', '');
      box.setAttribute('data-wom-check-box', '');
      var text = Array.prototype.find.call(row.children, function (/** @type {Element} */ child) {
        return child !== box && normalize(child.textContent) !== '';
      });
      var offset = 0;
      if (text) {
        var style = getComputedStyle(text);
        var lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.2;
        offset = Math.max(0, (lineHeight - boxHeight) / 2);
      }
      /** @type {HTMLElement} */ (box).style.setProperty('--wom-check-offset', offset + 'px');
      input.setAttribute('data-wom-aligned', '');
    }
  }

  // Returns the form-level wrapper for a field: the select container or the input's field container
  /** @param {ShadowRoot} root @param {string} id */
  function fieldContainer(root, id) {
    var label = root.getElementById(id + '-selector-label');
    if (label) return label.parentElement;
    var input = root.getElementById(id);
    return input ? input.parentElement : null;
  }

  /** @param {ShadowRoot} root */
  function pairRows(root) {
    for (var i = 0; i < ROWS.length; i++) {
      var row = ROWS[i];
      if (!row) continue;
      var start = fieldContainer(root, row.fields[0] || '');
      var end = fieldContainer(root, row.fields[1] || '');
      if (!start || !end || !start.parentElement || start.parentElement !== end.parentElement) continue;
      start.parentElement.setAttribute('data-wom-wrap', '');
      start.setAttribute('data-wom-row-start', '');
      start.style.setProperty('--wom-row-split', row.split);
      end.setAttribute('data-wom-row-end', '');
    }
  }

  /** @param {ShadowRoot} root */
  function inlineSelectLabels(root) {
    for (var i = 0; i < INLINE_SELECT_LABELS.length; i++) {
      var id = INLINE_SELECT_LABELS[i];
      var label = id && root.getElementById(id + '-selector-label');
      var button = label && label.parentElement && label.parentElement.querySelector('button');
      if (!label || !button || button.hasAttribute('data-wom-select-placeholder')) continue;
      var value = root.getElementById(id + '-selector-value');
      if (value) value.setAttribute('data-wom-placeholder', (label.textContent || '').trim());
      // Borrows the floating-label color from a text field so the placeholder matches the others
      var floating = root.querySelector('label[class*="_formInputFieldLabel_"]');
      if (floating) button.style.setProperty('--wom-placeholder-color', getComputedStyle(floating).color);
      button.setAttribute('data-wom-select-placeholder', '');
      label.setAttribute('data-wom-hidden', '');
    }
  }

  // Copies the class of the app's own select label so the heading follows the form's typography
  /** @param {ShadowRoot} root */
  function addHeadings(root) {
    Object.keys(HEADINGS).forEach(function (id) {
      var field = fieldContainer(root, id);
      var parent = field && field.parentElement;
      if (!field || !parent) return;
      var previous = field.previousElementSibling;
      if (previous && previous.hasAttribute('data-wom-heading')) return;
      var source = root.querySelector('p[id$="-selector-label"]');
      var heading = document.createElement('p');
      heading.className = source ? source.className : '';
      heading.setAttribute('data-wom-heading', '');
      heading.textContent = HEADINGS[/** @type {keyof typeof HEADINGS} */ (id)];
      parent.insertBefore(heading, field);
    });
  }

  /** @param {ShadowRoot} root */
  function addTooltips(root) {
    Object.keys(TOOLTIPS).forEach(function (id) {
      var input = root.getElementById(id);
      var field = input && input.parentElement;
      if (!field || field.querySelector('.wom-tip')) return;
      var bubbleId = 'wom-tip-' + id.replace(/[^a-z0-9_-]/gi, '-');
      var tip = document.createElement('span');
      tip.className = 'wom-tip';
      tip.innerHTML =
        '<button type="button" class="wom-tip__btn" aria-label="More info" aria-expanded="false" aria-describedby="' +
        bubbleId +
        '">?</button><span class="wom-tip__bubble" role="tooltip" id="' +
        bubbleId +
        '"></span>';
      var bubble = tip.querySelector('.wom-tip__bubble');
      if (bubble) bubble.textContent = TOOLTIPS[/** @type {keyof typeof TOOLTIPS} */ (id)];
      field.setAttribute('data-wom-tip-field', '');
      field.appendChild(tip);
      fitTip(field);
    });
  }

  // Caps the bubble at the space between the field's right edge and the form's left edge, which clips overflow
  /** @param {HTMLElement} field */
  function fitTip(field) {
    var form = field.closest('form');
    if (!form) return;
    var update = function () {
      var max = field.getBoundingClientRect().right - /** @type {HTMLFormElement} */ (form).getBoundingClientRect().left;
      field.style.setProperty('--wom-tip-max', Math.max(160, Math.floor(max)) + 'px');
    };
    update();
    new ResizeObserver(update).observe(form);
  }

  /** @param {ParentNode} scope @param {Element | null} [except] */
  function closeTips(scope, except) {
    scope.querySelectorAll('.wom-tip[data-open]').forEach(function (tip) {
      if (tip === except) return;
      tip.removeAttribute('data-open');
      tip.querySelector('.wom-tip__btn')?.setAttribute('aria-expanded', 'false');
    });
  }

  // Click toggles the tooltip for touch screens; delegated so it survives app re-renders
  /** @param {Element} embed @param {ShadowRoot} root */
  function bindTooltips(embed, root) {
    root.addEventListener('click', function (event) {
      var target = /** @type {Element} */ (event.target);
      var btn = target.closest && target.closest('.wom-tip__btn');
      var tip = btn && btn.parentElement;
      closeTips(root, tip);
      if (!btn || !tip) return;
      var open = !tip.hasAttribute('data-open');
      tip.toggleAttribute('data-open', open);
      btn.setAttribute('aria-expanded', String(open));
    });
    root.addEventListener('keydown', function (event) {
      if (/** @type {KeyboardEvent} */ (event).key === 'Escape') closeTips(root);
    });
    document.addEventListener('click', function (event) {
      if (event.composedPath().indexOf(embed) === -1) closeTips(root);
    });
  }

  /** @param {ShadowRoot} root */
  function apply(root) {
    hideLabels(root);
    alignCheckboxes(root);
    pairRows(root);
    inlineSelectLabels(root);
    addHeadings(root);
    addTooltips(root);
  }

  /** @param {ShadowRoot} root */
  function addStyles(root) {
    try {
      var sheet = new CSSStyleSheet();
      sheet.replaceSync(STYLES);
      root.adoptedStyleSheets = root.adoptedStyleSheets.concat(sheet);
    } catch (e) {
      var style = document.createElement('style');
      style.textContent = STYLES;
      root.appendChild(style);
    }
  }

  /** @param {Element} embed */
  function enhance(embed) {
    const root = embed.shadowRoot;
    if (!root || enhanced.has(root)) return;
    enhanced.add(root);
    // The app redefines the paragraph size inside the form, so the theme's value is copied from the host
    var hostStyle = getComputedStyle(embed);
    var host = /** @type {HTMLElement} */ (embed);
    host.style.setProperty('--wom-paragraph-size', hostStyle.getPropertyValue('--font-paragraph--size'));
    host.style.setProperty('--wom-paragraph-line-height', hostStyle.getPropertyValue('--font-paragraph--line-height'));
    addStyles(root);
    bindTooltips(embed, root);
    apply(root);
    // The app renders asynchronously and re-renders on step changes or validation
    new MutationObserver(function () {
      apply(root);
    }).observe(root, { childList: true, subtree: true });
  }

  /** @param {Node} node */
  function scan(node) {
    if (!(node instanceof Element)) return;
    if (node.localName === 'shopify-forms-embed') enhance(node);
    var embeds = node.querySelectorAll('shopify-forms-embed');
    for (var i = 0; i < embeds.length; i++) enhance(/** @type {Element} */ (embeds[i]));
  }

  function init() {
    scan(document.body);
    // The app injects the embed after load, so watch for it being added
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i]?.addedNodes || [];
        for (var j = 0; j < added.length; j++) scan(/** @type {Node} */ (added[j]));
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
